import { Grid } from "@mui/material";
import { PlatformsEnum } from "src/constants/platforms";
import DashboardCards from "src/sections/dashboards/charts/dashboard-cards";
import { DashboardType } from "src/types/types";
import DashboardStatisticsGroupContainer from "../../charts/dashboard-statistics-group-container/dashboard-statistics-group-container";
import { STATISTICS } from "../../charts/dashboard-statistics-group-container/statistics";
import SentimentChart from "../../charts/sentiment-chart/sentiment-chart";
import DashboardViewLayout from "../../../../layouts/dashboard/view/dashboard-view-layout";
import useNYCTimesDashboardView from "./use-nyc-times-dashboard-view";

const NYCTimesDashboardView = ({ type }: { type: DashboardType }) => {
  const { platformData, isDataLoading, error } = useNYCTimesDashboardView({ type });

  return (
    <DashboardViewLayout
      isLoading={isDataLoading}
      type={type}
      platform={PlatformsEnum.NYC_TIMES}
      pageTitle="Adam Radar | NYC Times dashboard"
      error={error}
    >
      <Grid item xs={12}>
        {platformData?.analysis.cards?.length && (
          <DashboardCards cards={platformData?.analysis.cards} />
        )}
      </Grid>
      {platformData?.analysis.pieChart && (
        <Grid item xs={12}>
          <SentimentChart data={platformData?.analysis.pieChart} />
        </Grid>
      )}
      {platformData && (
        <Grid item xs={12}>
          <DashboardStatisticsGroupContainer statistics={STATISTICS(platformData)} />
        </Grid>
      )}
    </DashboardViewLayout>
  );
};

export default NYCTimesDashboardView;
